import { PublicKeyCredentialWithAssertionJSON } from '@github/webauthn-json/dist/types/basic/json';
import { clientAuthAxios } from './clientAuth';

// eslint-disable-next-line no-shadow
export enum PasskeyLoginEndpointScope {
  android = 'android',
  web = 'web',
}

export const getPasskeyLoginOptions = ({
  scope,
}: {
  scope?: PasskeyLoginEndpointScope;
}) => clientAuthAxios.post('passkey_sessions/options_for_get', { scope });

export const loginWithPasskey = ({
  credential,
  scope,
}: {
  credential: PublicKeyCredentialWithAssertionJSON;
  scope?: PasskeyLoginEndpointScope;
}) => clientAuthAxios.post('/passkey_sessions', { credential, scope });
